const formatDateTime = (dateString, timeString) => {
    if (!dateString || !timeString) return "";

    // Parse the date
    const date = new Date(dateString);

    // Extract hours and minutes from the time string
    const [hours, minutes] = timeString.split(":").map((t) => t.trim());

    // Set time to the date
    date.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0); // Seconds set to 00

    // Format date and time in "YYYY-MM-DD HH:MM:SS"
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const hour = date.getHours().toString().padStart(2, "0");
    const minute = date.getMinutes().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hour}:${minute}:00`;
};

// Export function
export default formatDateTime;
